module.exports = __webpack_public_path__ + "static/stage-a5b0df6341bc9f742531b94734440fbd.jpg";